import {formatCurrency} from "../../utils/format";
import React from "react";

export function AccordionItemPresentValueHeader(props: { value: number }) {
    return <div className="accordion-item-present-value-header">
        {formatCurrency(props.value)}
    </div>;
}